<section class="max-w-md">
  <p>{{ data.message.text | transloco: data.message.replacements }}</p>

  <div class="btnsContainer">
    <a mat-raised-button *ngFor="let btn of data.buttons" [id]="btn.id" (click)="getBtnAction(btn)">
      {{ btn.text | transloco }}
    </a>
  </div>
</section>
